export default __webpack_public_path__ + "static/media/trustpilot-4-and-half-stars.ebea16ff.svg";